<template>
  <div class="content-wrapper">
    <div class="row align-items-center">
      <div class="col-md-12 col-lg-6">
        <div class="d-flex align-items-center">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb p-0 d-flex align-items-center mb-primary">
              <li class="breadcrumb-item page-header d-flex align-items-center">
                <h4 class="mb-0">{{ pageTitle }}</h4>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <app-filter-with-search
        :options="options"
        @filteredValue="setFilterValues"
        @searchValue="setSearchValue"
    />
    <div>
      <app-overlay-loader v-if="preLoader"/>


      <div class="card card-with-shadow border-0" style="min-height: 400px;">
        <div>
          <div
              class="card-header d-flex align-items-center justify-content-between primary-card-color p-primary mb-primary">
            <app-month-calendar/>

            <app-period-calendar :filters="periodFilters"
                                 :initial-filter-value="'thisMonth'"/>
          </div>
        </div>

        <app-table
            id="transaction-table"
            :options="tableOptions"
            @action="triggerActions"
        />
      </div>

      <app-confirmation-modal
          v-if="exportConfirmationModal"
          :title="modalSubtitle"
          :message="modalMessage"
          modal-id="app-confirmation-modal"
          modal-class="primary"
          icon="download"
          :first-button-name="$t('export')"
          :second-button-name="$t('cancel')"
          @confirmed="exportFilteredAsset()"
          @cancelled="exportConfirmationModal = false"
          :self-close="false"
      />

      <app-confirmation-modal
          v-if="confirmationModalActive"
          :loading="loading"
          :message="promptMessage"
          :title="promptTitle"
          :second-button-name="actionType === 'none' ? $t('okay') : $t('no')"
          :hide-first-button="actionType === 'none'"
          :modal-class="promptClass"
          :icon="promptIcon"
          modal-id="app-confirmation-modal"
          @confirmed="confirmed"
          @cancelled="confirmationModalActive = false"
          :self-close="false"
      />

    </div>

  </div>
</template>

<script>

import TransactionMixin from "../../Mixins/TransactionMixin";
import TransactionItemsRow from "./Components/TransactionItemsRow";
import {axiosGet, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {PAYSLIP, TRANSACTIONS} from "../../../Config/ApiUrl";
import {localTimeZone} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
  name: "transactions",
  mixins: [TransactionMixin],
  components: {TransactionItemsRow},
  data() {
    return {
      selectedUrl: '',
      pageTitle: this.$t('transactions'),
      transactions: {},
      paginationData: {},
      preLoader: false,
      updateTransactionId: '',
      confirmationModalActive: false,
      promptClass: '',
      promptIcon: '',
      promptMessage: '',
      payslipViewModal: false,
      payslipEditModal: false,
      payslipConflictModal: false,
      selectedTransaction: {},
      actionType: '',
      loading: false,
      promptTitle: this.$t('are_you_sure'),
      exportConfirmationModal: false,
      modalMessage: '',
      modalSubtitle: '',

    }
  },
  mounted() {
  },
  created() {
    this.$store.dispatch('getStatuses', 'payment')
  },
  methods: {
    filteredTransactionConfirmation() {
      if (this.tableData < 1) {
        this.promptTitle = this.$t('no_transaction_found');
        this.promptMessage = this.$t('please_filter_your_transaction_first');
        this.promptClass = 'warning';
        this.actionType = 'none';
      } else {
        this.promptClass = 'primary';
        this.promptMessage = this.$t('are_you_sure');
        this.promptTitle = this.$t('sending_filtered_transaction');
        this.actionType = 'sendFiltered';
      }
      this.promptIcon = 'filter';
      this.confirmationModalActive = true;
    },
    viewConfirmationModal() {
      this.modalSubtitle = this.$t('all_transaction_export_title');
      this.modalMessage = this.$t('all_transaction_export_message');
      this.exportConfirmationModal = true;
    },
    exportFilteredAsset() {
      window.location = urlGenerator(`${this.apiUrl.EXPORT}/transaction/all?timeZone=${localTimeZone}`);
      $("#app-confirmation-modal").modal('hide');
      $(".modal-backdrop").remove();
      this.exportConfirmationModal = false;
    },
    triggerActions(row, action, active) {
      if (action.actionName === 'edit') {
        this.selectedPayslip = row
        this.payslipEditModal = true;
      }
    },
    closeConfirmation() {
      $("#app-confirmation-modal").modal('hide');
      $(".modal-backdrop").remove();
      this.loading = false;
      this.confirmationModalActive = false;
    },
    afterUpdated() {
      $("#transaction-edit-modal").modal('hide');
      $(".modal-backdrop").remove();
      this.transactionEditModal = false;
      this.$hub.$emit('reload-transaction-table');
    },
    setUrlAndReloadTable() {
      this.tableOptions.url = `${TRANSACTIONS}?${this.queryString}`;
      this.$hub.$emit('reload-transaction-table');
    },
  },
  computed: {
    queryString() {
      return this.$store.getters.getFilterUrls;
    },
  },
  watch: {
    queryString: {
      handler: function (queryString) {
        if (!queryString) {
          return;
        }
        this.setUrlAndReloadTable()
      },
      immediate: true
    }
  },
}
</script>